import React, { useEffect, useState } from "react";
import "./menu.css";
import { Menu } from "antd";
import styled from "styled-components";

const StyledMenu = styled(Menu)`
  &.ant-menu-horizontal {
    border: none !important; // 去掉底部边框
    color: #000;
  }

  .ant-menu-item::after,
  .ant-menu-submenu::after {
    border-bottom: none !important; /* 去掉底部的蓝色下边框 */
  }

  .ant-menu-item,
  .ant-menu-submenu-title {
    font-family: 'Arial', sans-serif; // 设置字体架次为 Arial
    border-radius: 0 0 0 0;
    transition: all 0.3s ease-in-out; /* 使用通用过渡 */
    font-weight: bold; // 加粗字体

    &:hover {
      text-shadow: 1px 1px 2px rgba(0, 0, 0, 0.4); /* 使用 text-shadow 模拟加粗效果 */
      border-bottom: none !important; /* 去掉底部的蓝色下边框 */
    }
  }

  .ant-menu-item-selected {
    border-bottom: none !important; // 强制去掉默认的选中下划线
    text-shadow: 1px 1px 2px rgba(0, 0, 0, 0.4) !important; // 选中时添加 text-shadow
    color: #000 !important; // 选中且划过文字颜色
    &:hover {
      background-color: transparent !important;
      color: #000 !important; // 选中且划过文字颜色
    }
  }

  .ant-menu-submenu-selected::after {
    border-bottom: none !important; /* 去掉选中时的蓝色下边框 */
    color: #000 !important; // 选中且划过文字颜色
  }

  .ant-menu-submenu-selected {
    border-bottom: none !important; // 强制去掉默认的选中下划线
    text-shadow: 1px 1px 2px rgba(0, 0, 0, 0.4) !important; // 选中时添加 text-shadow
    color: #000 !important; // 选中且划过文字颜色
    .ant-menu-submenu-title {
      text-shadow: 1px 1px 2px rgba(0, 0, 0, 0.4) !important;
      color: #000 !important; // 选中且划过文字颜色
    }
  }
`;


const items = [
  {
    key: "1",
    label: <a href="/lotus/home/">Home</a>,
  },
  {
    key: "2",
    label: <a href="/lotus/resource/">Resource</a>,
  },
  {
    key: "3",
    label: <p>Genome</p>,
    children: [
      { key: "3.1", label: <a href="/lotus/genomes">Assembly and Annotation</a> },
      { key: "3.2", label: <a href="/lotus/geneindex/">Gene Index</a> },
    ],
  },
  {
    key: "6",
    label: <p>Populations</p>,
    children: [
      
      {
        key: "6.1",
        label: <a href="/lotus/structure/">Population Structure</a>,
      },
      {
        key: "6.2",
        label: <a href="/lotus/mutationinform/">Mutation information query</a>,
      }
    ],
  },
  {
    key: "4",
    label: <p>Transcriptome</p>,
    children: [
      { key: "4.1", label: <a href="/lotus/ranseq/">RNA-seq</a> },
      { key: "4.2", label: <a href="/lotus/expressionanalysis/">Expression analysis</a> },
      // {
      //   key: "4.3",
      //   label: <a href="/lotus/comparative/">Comparative transcriptomics</a>,
      // },
    ],
  },
  {
    key: "5",
    label: <a href="/lotus/searchmetabolome/">Metabolome</a>,
    // children: [
    //   {
    //     key: "5.1",
    //     label: <a href="/lotus/searchmetabolome/">Search metabolite</a>,
    //   },
     
    // ]
  },
 
  {
    key: "7",
    label: <a href="/lotus/epigenome/">Epigenome</a>,
  },
  {
    key:"11",
    label: <a href="https://pfmgp.bioaibp.com/#/Breeding/PFMGP/" target="_blank">PFMGP</a>,
  },

  {
    key: "8",
    label: <p>Tools</p>,
    children: [
      { key: "8.1", label: <a href="/lotus/jbrowse/">Jbrowse</a> },
      { key: "8.2", label: <a href="/lotus/blast/">BLAST</a> },
      { key: "8.3", label: <a href="/lotus/gokegg/">GO/KEGG enrichment</a> },
      // { key: "8.4", label: <a href="/lotus/domain/">Domain search</a> },
      { key: "8.5", label: <a href="/lotus/design">Primer design</a> },
      { key: "8.6", label: <a href="/lotus/heatmap/">Heatmap</a> },
      { key: "8.7", label: <a target="_blank" href="https://planttfdb.gao-lab.org/prediction.php">TF</a> },
    ],
  },
  { key: "9", label: <a href="/lotus/download/">Download</a> },
  { key: "10", label: <a href="/lotus/help/">Help</a> },
];

const MenuComponent = () => {
  const [current, setCurrent] = useState(
    sessionStorage.getItem("MenuKey") ? sessionStorage.getItem("MenuKey") : ""
  );
  const onClick = (e) => {
    sessionStorage.setItem("MenuKey", e.key);
    setCurrent(e.key);
  };
  useEffect(() => {
    setCurrent(sessionStorage.getItem("MenuKey"));
  }, [sessionStorage.getItem("MenuKey")]);

  return (
    <StyledMenu
      onClick={onClick}
      selectedKeys={[current]}
      mode="horizontal"
      items={items}
      style={{
        width: "100%",
        height: "60px", // 适当设置高度
        background: "#BDF7C1", // 设置背景色
        display: "flex",
        alignItems: "center",
        color: "#000", // 默认字体颜色
      }}
    />
  );
};

export default MenuComponent;
